import { useCallback } from 'react'
import { useDisabledOnsite } from '../../store/paymentMethod'
import { usePaymentMethod } from '../../store/stateMachine/context'
import { useTransition } from '../../store/stateMachine/state'

export function useOnsitePayment() {
  const selectedPaymentMethod = usePaymentMethod()
  const send = useTransition()
  const disabled = useDisabledOnsite()
  const checkedOnsite = useCallback(() => {
    send({ type: 'updated', paymentMethod: 'ONSITE' })
  }, [send])
  return { selectedPaymentMethod, disabled, checkedOnsite }
}
